import { render, staticRenderFns } from "./OnlineDelivery.vue?vue&type=template&id=8a439df2"
import script from "./OnlineDelivery.vue?vue&type=script&lang=js"
export * from "./OnlineDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports